import { HgSupportedLanguage } from '@smg-real-estate/domus';

/**
 * Temporary solution for 1st MVP:
 * Due to - Only "canton" and "city" can be indexed from SEO
 *          And IAZI supports "municipality" rather than "city"
 * So, Only show "city" on URL, the internal logic still use "municipality"
 *
 * Location format on URL:
 * Canton: /canton-zurich
 * Municipality: /city-zurich
 * Ziptown: /city-zurich?zipCity=8006-zurich
 * */
const SPLIT_SEPARATOR = '|';
export const cityLocale = {
  [HgSupportedLanguage.EN]: 'city',
  [HgSupportedLanguage.DE]: 'ort',
  [HgSupportedLanguage.FR]: 'lieu',
  [HgSupportedLanguage.IT]: 'luogo',
};

export const municipalityLocale = {
  [HgSupportedLanguage.EN]: 'municipality',
  [HgSupportedLanguage.DE]: 'gemeinde',
  [HgSupportedLanguage.FR]: 'municipalite',
  [HgSupportedLanguage.IT]: 'comune',
};

export const zipLocale = {
  [HgSupportedLanguage.EN]: 'zip|postcode',
  [HgSupportedLanguage.DE]: 'plz',
  [HgSupportedLanguage.FR]: 'npa',
  [HgSupportedLanguage.IT]: 'npa',
};
const cantonLocale = {
  [HgSupportedLanguage.EN]: 'canton',
  [HgSupportedLanguage.DE]: 'kanton',
  [HgSupportedLanguage.FR]: 'canton',
  [HgSupportedLanguage.IT]: 'cantone',
};

const getGeoUrlPrefixes = (language: HgSupportedLanguage): string[] => [
  cityLocale[language],
  municipalityLocale[language],
  cantonLocale[language],
  ...zipLocale[language].split(SPLIT_SEPARATOR),
];

export const getMatchingGeoUrlLanguages = (param: string): HgSupportedLanguage[] =>
  Object.values(HgSupportedLanguage).filter((language) =>
    getGeoUrlPrefixes(language).some((prefix) => param.startsWith(`${prefix}-`)),
  );

export const getGeoUrlLanguageCandidates = (
  param: string,
  preferredLanguage: HgSupportedLanguage,
): HgSupportedLanguage[] => {
  const matchingLanguages = getMatchingGeoUrlLanguages(param);

  if (matchingLanguages.length === 0) {
    return [preferredLanguage];
  }

  return [
    ...(matchingLanguages.includes(preferredLanguage) ? [preferredLanguage] : []),
    ...matchingLanguages.filter((language) => language !== preferredLanguage),
  ];
};

export const getGeoUrlNameByUrl = ({
  param,
  zipQuery,
  language,
}: {
  param: string;
  zipQuery?: string;
  language: HgSupportedLanguage;
}): string => {
  if (zipQuery) {
    return `${zipLocale[language].split(SPLIT_SEPARATOR)[0]}-${zipQuery}`;
  }
  return param.startsWith(cityLocale[language])
    ? param.replace(cityLocale[language], municipalityLocale[language])
    : param;
};

export const replaceGeoTagReg = (tag: string): RegExp =>
  new RegExp(`^(${tag.split(SPLIT_SEPARATOR).join('|')})-`);
